
import { create } from "zustand";
import { devtools } from "zustand/middleware";





const storeApi = (set) => ({

    activarUnidadMedida: null,
    totalUnidades: 0,


    setActivarUnidadMedida: (valor) => {
        set({ activarUnidadMedida: valor })
    },


    setTotalUnidades: (valor) => {
        set({ totalUnidades: valor })
    },

});





export const useUnidadesMedidaStore = create(
    devtools(
        storeApi
    )
)
